import { render, staticRenderFns } from "./NextEventsWidget.vue?vue&type=template&id=684306db"
import script from "./NextEventsWidget.vue?vue&type=script&lang=js"
export * from "./NextEventsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports